import "./form-features.scss";

import { TenantFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import { Divider } from "primereact/divider";
import { useFormContext } from "react-hook-form";

type InputFormSchema = TenantFormSchema;
export function FormFeatures() {
  const { control } = useFormContext<TenantFormSchema>();

  return (
    <div id="FormFeatures" className="tenant">
      <div>
        <h2>Optional Features (For Bukolabs Only)</h2>
        <Divider />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="featureQuota"
          label="Quota Feature"
          containerClassName="pb-2"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="featureSplashScreen"
          label="Splash Screen Feature"
          containerClassName="pb-2"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="featureCoupon"
          label="Coupon Feature"
          containerClassName="pb-2"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="featureReferral"
          label="Referral Feature"
          containerClassName="pb-2"
        />
      </div>
    </div>
  );
}

export default FormFeatures;
